export async function fetchResponse(endpoint) {
  return fetch(
    endpoint,
    { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }
  )
}
